import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'
import ImgUtil from '../../../utils/img.utils'

export const ResourceRowContainer = styled.div`
  padding: 64px 0 0 0;
  background: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};

  .ResourseRow_Intro {
    text-align: center;
  }

  .ResourseRow_Intro + div {
    padding-top: 64px;
  }
`

export const TimezoneOverrideContainer = styled.div`
  text-align: center;
  padding: 128px 0;
  background: url(${ImgUtil.getResizedImageUrl(ASSETS.TIMEZONE_THANK_YOU, '')});
  background-size: cover;
  background-repeat: no-repeat;

  .TimeZoneOverried__Icon {
    width: 64px;
    height: 64px;
    margin-bottom: 32px;
  }

  .EmbeddedIconButton {
    margin: 32px 0;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: calc(100% - 32px);
      margin-left: 16px;
      margin-right: 16px;
      margin-bottom: 0;
    }
  }
  .EmbeddedIconButton + .EmbeddedIconButton {
    margin-left: 16px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin-top: 16px;
    }
  }
`
